<template>
  <div id="container" v-if="resetFlag">
    <div>
      <div class="IEO-info panel">
        <dl class="IEO-description">
          <dt>
            <h2 class="title">
              <!-- 디폴트 -->
              <div class="image-wrap">
                <img
                  class="icon"
                  :src="
                    `//static.flybit.com/static/img/ieo/ieo_pr_${IEOInfo.ieCode}.png?v=${imageVersion}`
                  "
                  :alt="IEOInfo.ieName"
                />
              </div>
            </h2>
          </dt>
        </dl>
        <!-- 메뉴 탭 -->
        <div id="menuTab" class="title-wrap">
          <!-- 뱃지 -->
          <div flex>
            <div v-if="DealStatus === 'end'" class="badge-wrap end" flex>
              <i
                class="el-icon-success"
                style="color: #707a8a; margin-right: 5px;"
              />
              <div>
                <p class="status-badge end">
                  {{ "진행 종료" }}
                </p>
              </div>
            </div>
            <div v-else class="badge-wrap" flex>
              <i
                class="el-icon-success"
                style="color: #eb3246; margin-right: 5px;"
              />
              <div v-if="moment(IEOInfo.startDatetime) > moment()">
                <p class="status-badge soon">
                  D-{{
                    getRemainDate(IEOInfo) != 0 ? getRemainDate(IEOInfo) : "day"
                  }}
                </p>
                <!-- <p class="status-badge soon">{{ "진행 예정" }}</p> -->
              </div>
              <div v-else>
                <p class="status-badge ing">{{ "진행중" }}</p>
              </div>
            </div>
            <!-- whitelist badge -->
            <div v-if="isWhiteList" class="badge-wrap whiteList ml10" flex>
              <i
                class="el-icon-success"
                style="color: #009a72; margin-right: 5px;"
              />
              <p class="status-badge whiteList">
                {{ "WhiteList" }}
              </p>
            </div>
            <!-- // whitelist badge -->
          </div>
          <!-- // 뱃지 -->
          <div class="tkName mb4">{{ getTitle(IEOInfo.tkName) }}</div>
          <!-- <p>{{ `시작 ${IEOInfo.startDatetime} ~${IEOInfo.startDatetime}` }}</p> -->
          <p>
            <span class="c-gray">시작</span>
            {{ convertDateFormat(IEOInfo.startDatetime) }}
          </p>
          <p>
            <span class="c-gray">종료</span>
            {{ convertDateFormat(IEOInfo.endDatetime) }}
          </p>
          <!-- 판매종료 카운트다운 -->
          <div v-if="endRemainDate && DealStatus === 'ing'" class="mt4" flex>
            <p class="mr5" style="line-height: 18px">{{ `판매 종료까지` }}</p>
            <p class="keycolor" style="line-height: 18px">
              {{
                `${endRemainDate.split("@")[0]}${$t("ieo.trade.days")}${
                  endRemainDate.split("@")[1]
                }${$t("ieo.trade.hours")}${endRemainDate.split("@")[2]}${$t(
                  "ieo.trade.minutes"
                )}${endRemainDate.split("@")[3]}${$t("ieo.trade.seconds")}`
              }}
            </p>
          </div>
          <!-- // 판매종료 카운트다운 -->
          <div class="tab" flex>
            <div
              v-for="(saleOption, index) in saleOptions"
              :key="index"
              :class="{ active: isActive == index }"
              class="menu"
              @click="changeDeal(saleOption.value, index)"
            >
              <p>{{ saleOption.value }}</p>
            </div>
          </div>
          <!-- 트레이드 -->
          <div class="trade">
            <trade
              v-if="IEOInfo.ieCode"
              :tk-code="$route.params.tkCode"
              :deal-info="selectedDeal"
              :ieo-info="IEOInfo"
              :whiteListModal="closePopup"
              :isWhiteList="isWhiteList"
              @trade="getSaleData"
            ></trade>
          </div>
        </div>
      </div>

      <div class="IEO-history panel">
        <!-- 거래내역 -->
        <h2 class="title">{{ $t("ieo.concluded.history") }}</h2>
        <div class="hidden-table">
          <div
            @click="showTable = !showTable"
            :class="{ hidden: showTable }"
            class="more"
          >
            {{ $t("ieo.detail.more") }}
          </div>
          <div
            @click="showTable = !showTable"
            :class="{ show: showTable }"
            class="less"
          >
            {{ $t("ieo.detail.less") }}
          </div>
        </div>
        <div :class="{ show: showTable }" class="history-table">
          <History :tk-code="tkCode" :ie-code="IEOInfo.ieCode" />
        </div>
      </div>
      <div class="trade-info contents">
        <div
          class="IEO-assignment"
          v-if="$i18n.locale == 'ko'"
          v-html="htmlReplace(IEOInfo.mContents)"
        ></div>
        <div
          class="IEO-assignment"
          v-if="$i18n.locale == 'ch'"
          v-html="htmlReplace(IEOInfo.mContentsCa)"
        ></div>
        <div
          class="IEO-assignment"
          v-if="$i18n.locale == 'en'"
          v-html="htmlReplace(IEOInfo.mContentsEn)"
        ></div>
      </div>
    </div>

    <!-- 플로팅 버튼 -->
    <div class="floatingBtn">
      <!-- <a href="#menuTab"> -->
      <div @click="buttonBuying" class="floatingBtn buy">
        <!-- {{ "구매" }} -->
      </div>
    </div>

    <template v-if="whiteListData">
      <Popup
        v-if="isWhiteList && whiteListData && whiteListData.is_show"
        :isShow="whiteListData.is_show"
        :closePopup="closePopup"
        :popData="{
          title: '토큰스왑 참여 안내',
          confirm: '확인',
        }"
      >
        <div
          slot="content"
          class="popup-content"
          v-html="nl2br(whiteListData.content)"
        ></div>
      </Popup>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import Decimal from "decimal.js";
import Api from "../../common/Api";
import History from "./History";
import Trade from "./Trade";
import { mapGetters, mapActions, mapState } from "vuex";
import Popup from "@/components/common/Popup.vue";

export default {
  name: "IEODetail",
  components: {
    History,
    Trade,
    Popup,
  },
  async created() {
    await this.getSaleData();
    const zendesk = document.getElementById("launcher");
    if (zendesk) {
      if (this.$route.path === "/") {
        document.getElementById("launcher").style.visibility = "visible";
      } else {
        document.getElementById("launcher").style.visibility = "hidden";
      }
    }
    setInterval(() => {
      this.endRemainDate = this.calcRemainDate(this.IEOInfo.endDatetime);
    }, 1000);
  },
  data: () => ({
    IEOInfo: {},
    selectedDealCode: "",
    resetFlag: true,
    isActive: 0,
    showTable: false,
    concludedListbyProps: [],
    addclass: false,
    progressdata: null,
    imageVersion: new Date().getTime(),
    // 화이트리스트 분기처리
    whiteListFlag: "(Whitelist)",
    whiteListData: null,
    endRemainDate: null,
    orderLists: false,
  }),
  computed: {
    ...mapGetters(["userInfo", "isLogin"]),
    ...mapState("Firebase", ["whiteListModalData"]),
    isWhiteList() {
      return this.IEOInfo.tkName.indexOf(this.whiteListFlag) === -1
        ? false
        : true;
    },
    ddayColor() {
      return {
        color: `${this.IEOInfo.dayPicker}`,
      };
    },
    tkCode() {
      return this.$route.params.tkCode;
    },
    saleOptions() {
      return _.get(this, ["IEOInfo", "tokenSaleDetailList"], []).map(
        ({ ciCode, ciName }) => ({
          name: `${ciName} (${ciCode})`,
          value: ciCode,
        })
      );
    },
    availCnt() {
      if (!this.IEOInfo.totalCount) {
        return 0;
      }
      return Decimal(this.IEOInfo.totalCount).sub(this.IEOInfo.ieCnt);
    },
    selectedDeal: {
      get: function() {
        return _.find(this.IEOInfo.tokenSaleDetailList, {
          ciCode: this.selectedDealCode,
        });
      },
      set: function(ciCode) {
        this.selectedDealCode = ciCode;
      },
    },
    isDealEnd() {
      return this.IEOInfo.completeYn === "Y";
    },
    isDealEarlyEnd() {
      return this.progressedPerc >= 99;
    },
    progressedPerc() {
      return (this.IEOInfo.ieCnt / this.IEOInfo.totalCount) * 100;
    },
    DealStatus() {
      if (moment(this.IEOInfo.startDatetime) > moment()) return "soon";
      else if (this.IEOInfo.completeYn === "Y") return "end";
      else if (
        new Decimal((this.IEOInfo.ieCnt / this.IEOInfo.totalCount) * 100).gte(
          99
        )
      )
        return "end";
      else if (
        !moment().isBetween(
          this.IEOInfo.startDatetime,
          this.IEOInfo.endDatetime
        )
      )
        return "end";
      else return "ing";
    },
  },

  methods: {
    ...mapActions("Firebase", ["AC_WHITELIST_MODAL"]),
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
    closePopup() {
      this.whiteListData.is_show = !this.whiteListData.is_show;
    },
    async setWhiteList() {
      await this.AC_WHITELIST_MODAL({
        key: "tokenSwapeWhiteList",
        code: this.IEOInfo.ieCode,
      });

      const vuexWhiteListData = _.cloneDeep(this.whiteListModalData);

      this.whiteListData = vuexWhiteListData.find(
        (content) => content.code === this.IEOInfo.ieCode
      );
      if (
        this.whiteListData &&
        (!this.isLogin || this.userInfo.configInfo.wowWhitelistYn === "N")
      ) {
        return (this.whiteListData.is_show = true);
      }
    },
    async getSaleData() {
      this.resetFlag = false;

      await Api.IEO.getSaleDetail(this.$route.params.tkCode).then(
        (response) => (
          (this.IEOInfo = _.get(response, ["data", "result"], {})),
          (this.selectedDealCode = _.get(
            this,
            ["IEOInfo", "tokenSaleDetailList", this.isActive, "ciCode"],
            ""
          ))
        )
      );

      // 화이트리스트 팝업 데이터 불러오기
      this.setWhiteList();

      this.$nextTick(() => (this.resetFlag = true));
    },
    dateProgress(startDate, endDate) {
      const period = moment.duration(moment(endDate).diff(startDate)).asDays();
      const remain = this.$options.filters.endAfter(endDate);
      return parseFloat((((period - remain) / period) * 100).toFixed(2)) || 0;
    },
    IEOProgress(total, avail) {
      return Decimal(avail)
        .div(total)
        .toFixed(5);
    },
    changeDeal(ciCode, index) {
      this.isActive = index;
      this.selectedDeal = ciCode;
    },
    remainSaleDate(startDatetime) {
      //d-day
      return (
        -1 *
        moment()
          .startOf("day")
          .diff(moment(startDatetime), "days")
      );
    },
    buttonBuying() {
      document.getElementById("menuTab").scrollIntoView();
    },
    buttonSummary() {
      document.getElementById("summary").scrollIntoView();
    },
    htmlReplace(html) {
      let result;
      result = html;
      if (html != null) {
        result = result.replaceAll("&lt;", "<");
        result = result.replaceAll("&gt;", ">");
        result = result.replaceAll("&amp;", "&");
        result = result.replaceAll("&apos;", "'");
        result = result.replaceAll("&quot;", '"');
        result = result.replaceAll("&nbsp;", " ");
      }
      return result;
    },
    getTitle(title) {
      return title.indexOf(this.whiteListFlag) === -1
        ? title
        : title.split(this.whiteListFlag)[0];
    },
    convertDateFormat(date) {
      return this.moment(date).format("YYYY.MM.DD hh:mm");
    },
    //판매 시작/종료까지 남은 시간
    calcRemainDate(targetDate) {
      const remainPeriod = moment.duration(moment(targetDate).diff(moment()));
      let RemainDate = "";
      if (remainPeriod.asDays() > 0) {
        RemainDate += `${remainPeriod.days()}@ `;
      }
      if (remainPeriod.asHours() > 0) {
        RemainDate += `${remainPeriod.hours()}@ `;
      }
      if (remainPeriod.asMinutes() > 0) {
        RemainDate += `${remainPeriod.minutes()}@ `;
      }
      if (remainPeriod.asSeconds() > 0) {
        RemainDate += `${remainPeriod.seconds()}@ `;
      } else {
        RemainDate = "---";
      }
      if (
        remainPeriod.days() == 0 &&
        remainPeriod.hours() == 0 &&
        remainPeriod.minutes() == 0 &&
        remainPeriod.seconds() == 0
      ) {
        return this.$router.go(0);
      }
      return RemainDate;
    },
    //Dday 구하는 함수
    getRemainDate(IEO) {
      return (
        -1 *
        moment()
          .startOf("day")
          .diff(moment(IEO.startDatetime), "days")
      );
    },
  },
  filters: {
    endAfter(date1) {
      return moment.duration(moment(date1).diff(moment())).asDays();
    },
    toDate(date, format = "YYYY-MM-DD") {
      return moment(date).format(format);
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  font-family: "spoqa Han Sans", "Noto Sans KR", sans-serif;
  p {
    margin-bottom: 0;
  }
}
.title {
  color: #000000;
  font-size: 18px;
  align-items: center;
  font-weight: bold;
  img.icon {
    width: 100%;
  }
  .image-wrap {
    position: relative;
    font-family: "spoqa Han Sans", "Noto Sans KR", sans-serif;
    border-bottom: 1px solid #dcdfe3;
    &.eventOver {
      position: relative;
      .image-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        .text-wrap {
          position: absolute;
          top: 45%;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          p {
            color: #fff;
            text-align: center;
            &.top {
              width: 250px;
              height: 60px;
              margin: 0 auto;
              border: 1px solid #fff;
              font-size: 25px;
              font-weight: bold;
              font-stretch: normal;
              line-height: 60px;
              letter-spacing: -0.5px;
            }
            &.sub {
              margin-top: 10px;
              font-size: 20px;
              font-weight: normal;
              line-height: normal;
              letter-spacing: -0.5px;
            }
          }
        }
      }
    }
    &.soldout {
      position: relative;
      .image-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        .text-wrap {
          position: absolute;
          top: 45%;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          p {
            color: #eb2020;
            text-align: center;
            &.top {
              width: 250px;
              height: 60px;
              padding: 0 20px;
              margin: 0 auto;
              border: 1px solid #eb2020;
              font-size: 25px;
              font-weight: bold;
              font-stretch: normal;
              line-height: 60px;
              letter-spacing: -0.5px;
            }
            &.sub {
              margin-top: 10px;
              font-size: 20px;
              font-weight: normal;
              line-height: normal;
              letter-spacing: -0.5px;
              color: #fff;
            }
          }
        }
      }
    }
    .Dday-wrap {
      position: absolute;
      top: 15px;
      right: 15px;
      .Dday {
        width: 66px;
        border: 1px solid;
        border-radius: 6px;
        line-height: 50px;
        text-align: center;
      }
    }
  }
  .period {
    padding: 15px 0;
    background: #f55151;

    div {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.29;
      letter-spacing: 0.5px;
      text-align: left;
      color: #ffffff;
      font-family: "spoqa Han Sans", "Noto Sans KR", sans-serif;
      text-align: center;
      &:last-child {
        margin-top: 7px;
      }
    }
  }
}
.title-wrap {
  padding: 10px;
  .badge-wrap {
    display: flex;
    width: fit-content;
    padding: 5px;
    margin-bottom: 4px;
    align-items: center;
    justify-content: center;
    color: #eb2020;
    border-radius: 4px;
    background-color: rgba(235, 50, 70, 0.1);
    .status-badge {
      width: fit-content;
      border-radius: 4px;
      font-size: 12px;
    }
    &.end {
      color: #707a8a;
      background-color: #e5e6ea;
    }
    &.whiteList {
      color: #00b473;
      background-color: rgba(0, 180, 115, 0.1);
    }
  }
  .tkName {
    /* padding: 0 15px; */
    font-size: 20px;
    font-weight: bold;
    line-height: 1.45;
    letter-spacing: normal;
    text-align: left;
    color: #222222;
  }
  .tab {
    margin-top: 10px;
    /* padding: 0 15px; */
    .menu {
      flex: 1;
      padding: 7px 0;
      text-align: center;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #222222;
      border: 1px solid #ccc;
      border-left: 0;
      background: #fff;
      &:first-child {
        border-left: 1px solid #ccc;
      }
      &.active {
        border: 1px solid #000f46;
        background: #000f46;
        color: #fff;
      }
    }
  }
}
.panel {
  box-sizing: border-box;
  /* font-size: 12px; */
  color: #000000;
  dl.IEO-description {
    dd {
      margin-top: 8px;
      display: inline-flex;
      align-items: center;
    }
  }
  .progress {
    margin: 7px 0px;
    .day-until {
      font-weight: bold;
      font-size: 1rem;
      margin-right: 7px;
    }
    .space-between {
      display: flex;
      justify-content: space-between;
      line-height: 2;
    }
  }
  .sales-info {
    font-size: 14px;
    dl.sales-numbers {
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      line-height: 2;
      margin-bottom: 12px;
      dt {
        flex: 0 0 25%;
      }
      dd {
        flex: 1 1 75%;
      }
    }
  }
}

.IEO-history {
  position: relative;
  padding: 0 10px;
  margin-top: 10px;
  font-family: "spoqa Han Sans", "Noto Sans KR", sans-serif;
  .title {
    padding-bottom: 8px;
    border-bottom: 1px solid #333;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: normal;
    color: #333333;
  }
  .hidden-table {
    position: absolute;
    top: 0px;
    right: 15px;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.46;
    letter-spacing: normal;
    color: #333d48;
    .more {
      padding-right: 15px;
      &:after {
        content: "";
        position: absolute;
        top: 3px;
        right: 0;
        width: 8px;
        height: 8px;
        margin-left: -12px;
        border-left: 1px solid #333d48;
        border-bottom: 1px solid #333d48;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        box-sizing: border-box;
      }
    }
    .less {
      display: none;
      padding-right: 15px;
      &:after {
        content: "";
        position: absolute;
        top: 7px;
        right: 0;
        width: 8px;
        height: 8px;
        margin-left: -12px;
        border-left: 1px solid #999;
        border-bottom: 1px solid #999;
        -webkit-transform: rotate(-225deg);
        transform: rotate(-225deg);
        box-sizing: border-box;
      }
    }
    .show {
      display: block;
    }
    .hidden {
      display: none;
    }
  }
  .history-table {
    display: none;
    &.show {
      display: block;
    }
  }
}
.trade {
  margin-top: 10px;
}
.trade-info {
  p {
    margin-bottom: 0;
  }
  &.contents {
    padding: 0 10px 10px;
    word-break: break-all;
  }
}
.floatingBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 20px;
  bottom: 90px;
  width: 62px;
  height: 62px;
  border-radius: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  background: #000f46;
  z-index: 1;
  &:after {
    content: "";
    position: absolute;
    top: 25px;
    left: 33px;
    width: 20px;
    height: 20px;
    margin-left: -12px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    box-sizing: border-box;
  }
}
.KYC-button {
  padding: 10px;
  font-size: 11px;
  border: 1px solid #afafaf;
  border-radius: 2px;
  color: #333;
  background-color: #fff;
}
.text-type01 a {
  text-decoration: underline;
  color: #1a0dab;
}

.popup-content {
  text-align: left;
  font-size: 12px;
}
.IEO-assignment {
  img {
    width: 100%;
  }
}
</style>
